import { Spinner } from "flowbite-react";
import { useFormStatus } from "react-dom";

function SubmitButton({ children, look, pendingLabel }) {
  const { pending } = useFormStatus();
  let addClass;
  let textClass;
  if (look === "gold") {
    addClass = "bg-gold";
    textClass = "text-black font-semibold ";
  }
  if (look === "clear") {
    addClass = " border-2 border-gold";
    textClass = "text-white font-semibold ";
  }
  if (look === "gold2") {
    addClass = "bg-gold";
    textClass = "text-lg md:text-xl font-medium text-black";
  }
  if (look === "clear2") {
    addClass = " border-2 border-gold";
    textClass = "text-white md:text-xl font-medium ";
  }
  return (
    <button
      type="submit"
      className={`inline-flex h-12 items-center justify-center gap-3 rounded-3xl px-6 py-3 md:px-8 md:py-5 ${addClass}`}
      disabled={pending}
    >
      {pending ? (
        <>
          <Spinner size="sm" />
          <div className={`${textClass} leading-relaxed`}>{pendingLabel}</div>
        </>
      ) : (
        <div className={`${textClass} leading-relaxed`}>{children}</div>
      )}
    </button>
  );
}

export default SubmitButton;
